module.exports = __webpack_public_path__ + "static/media/python.bcf6930f.svg";